import { Mui } from "@osu/react-ui";
import { selectFavoritedLinks } from "../../services/graphql/slices/preferences";
import { useSelector } from "react-redux";
import { navLinkDropdownStyles } from "../../styles/commonSx";
import { Link } from "react-router-dom";
import { linkablePathValues } from "../../Routes/paths";

export default function Favorites({ sx, ...props }) {
  const favoritedLinks = useSelector((state) => {
    return selectFavoritedLinks(state) ?? [];
  });

  if (!favoritedLinks?.length) {
    return (
      <Mui.MenuItem 
        component={Link}
        to={linkablePathValues.search}
        sx={navLinkDropdownStyles}
      >
        <Mui.Typography variant="body2" color="textSecondary">
          No bookmarks yet. Visit the search page to add some.
        </Mui.Typography>
      </Mui.MenuItem>
    );
  }

  return favoritedLinks.map(({ link, title, identifier }) => (
    <Mui.MenuItem key={`bookmark-${identifier || encodeURIComponent(link)}`} sx={sx} className="padding-y-0" disableGutters {...props}>
      <Mui.ListItemButton
        sx={navLinkDropdownStyles}
        component="a"
        href={link}
      >
        {title}
      </Mui.ListItemButton>
    </Mui.MenuItem>
  ));
}
